import React, { forwardRef, useEffect, useRef, useState } from 'react';
import { assignRefs } from '../../../utils/Global';
import styles from './InputTextLengthCounter.module.scss';

const Contador = ({ scrollBlock, totalLength, maxLen }) => {
    return (
        <div
            className={` ${styles.contador} `}
            style={{
                marginRight: scrollBlock ? '21px' : '9px',
            }}
        >
            {totalLength}/{maxLen}
        </div>
    );
};

const getClassByObject = (className) => {
    let retorno = '';
    if (typeof className === 'object') {
        retorno = Object.keys(className)
            .filter((key) => className[key])
            .join(' ');
    }
    return retorno;
};

function InputTextLengthCounter(
    { children, maxLen = 0, showInDisable = true, className, ...rest },
    ref
) {
    const [totalLength, setTotalLength] = useState(0);
    const childRef = useRef(null);

    const scrollBlock =
        childRef.current && childRef.current?.clientHeight < childRef.current?.scrollHeight
            ? true
            : false;

    const propsChild =
        maxLen > 0
            ? {
                  maxLength: maxLen,
                  onKeyUp: function () {
                      setTotalLength(`${childRef?.current?.value}`.length);
                  },
                  ref: assignRefs(ref, childRef),
                  style: {
                      paddingRight: scrollBlock ? '46px' : '50px',
                      resize: 'vertical',
                  },
                  ...rest,
                  className: `${getClassByObject(className)} ${children?.props?.className ?? ''}`,
              }
            : {
                  ...rest,
                  className: `${getClassByObject(className)} ${children?.props?.className ?? ''}`,
              };

    useEffect(() => {
        setTotalLength(`${childRef?.current?.value}`.length);
    }, [childRef.current?.value]);

    const child = React.cloneElement(children, propsChild);
    const view = child?.props?.disabled && !showInDisable ? styles.view : styles.none;
    const none = child?.props?.disabled && !showInDisable ? styles.none : '';
    return (
        <>
            <div className={`${styles.containerTextLength} ${none} `}>
                {child}
                <div className={`${styles.containerPrint}`}>
                    <p>{child?.ref?.current?.value ?? ''}</p>
                </div>
                <Contador scrollBlock={scrollBlock} totalLength={totalLength} maxLen={maxLen} />
            </div>
            {view !== styles.none && (
                <div className={`${styles.containerTextLength} ${view}`}>
                    <p>
                        <span className={styles.space} />
                        {child?.ref?.current?.value ?? ''}
                    </p>
                </div>
            )}
        </>
    );
}
export default forwardRef(InputTextLengthCounter);
